import { CustomScreen } from '@/components/layout/custom-screen';
import { BillingOrderInformationView } from '@/sections/management/accounts/billing-orders/views/billing-order-information-view';
import { fetchBillingOrderById } from '@/services/billing/billing.service';

import { fillWithZeros } from '@/utils/formatters/format-number';
import { useQuery } from '@tanstack/react-query';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { paths } from '@/routes/paths';

export default function Page() {
  const { t } = useTranslation();
  const { orderId } = useParams();

  const { data: orderData, isLoading: orderIsLoading } = useQuery({
    queryKey: ['billing-order', orderId, 'detail'],
    queryFn: () => fetchBillingOrderById(orderId!),
    enabled: !!orderId,
    refetchOnMount: 'always',
  });

  return (
    <>
      <Helmet>
        <title>
          {t('Billing Order Detail')}{' '}
          {orderData?.number ? `#${fillWithZeros(orderData.number, 6)}` : ''}
        </title>
      </Helmet>

      <CustomScreen
        heading={
          orderData?.number
            ? `${t('Edit Billing Order')} #${fillWithZeros(orderData.number, 6)}`
            : t('Edit Billing Order')
        }
        links={[
          { name: t('Accounts'), href: '/management/accounts' },
          { name: t('Billing Orders'), href: paths.management.accounts.billingOrders.root },
          {
            name: orderData?.number ? `#${fillWithZeros(orderData.number, 6)}` : t('Edit'),
          },
        ]}
        isLoading={orderIsLoading}
      >
        {orderData ? (
          <BillingOrderInformationView orderData={orderData} isLoading={orderIsLoading} />
        ) : null}
      </CustomScreen>
    </>
  );
}
